import { computed } from 'vue'
import { state, type MultiplayerSession } from '../state'
import { ensureLinkedPlayerBuildsForMultiplayerSessions } from './build-service'
import { ensureLinkedModuleBuilds } from './linked-module-builds-service'

export type MultiplayerSessionWithDate = MultiplayerSession & { parsedDate: Date }

export const multiplayerSessionsWithDate = computed(() =>
  Object.values(state.multiplayerSessions).map(
    (x): MultiplayerSessionWithDate => ({ ...x, parsedDate: new Date(x.date) })
  )
)

export function ensureMultiplayerSessionDependencies() {
  return Promise.all([ensureMultiplayerModules(), ensureLinkedPlayerBuildsForMultiplayerSessions()])
}

async function ensureMultiplayerModules() {
  const linkIds = [
    ...Object.values(state.registeredStates).map(x => x.linkedModuleBuildsId),
    ...Object.values(state.courses).map(x => x.linkedModuleBuildsId),
    ...Object.values(state.multiplayerSessions)
      .map(x => x.linkedModuleBuildsId)
      .filter((id): id is string => !!id)
  ]
  await ensureLinkedModuleBuilds(linkIds)
}
